import { OwcExpandable } from '@one/react';
import styled from 'styled-components';

export const ExpandableListComponent = styled(OwcExpandable)`
  gap: 0;

  owc-list {
    padding: 0px 1px 1px 1px;
    border-radius: 0 0 7px 7px;
  }
`;

export const ExpandableListContainer = styled.div.attrs({ slot: 'content' })`
  padding: 0 !important;
`;

export const ExpandableListEmptyContent = styled.div`
  padding: 1rem;
`;
